import { ThemeProvider } from '@/theme/ThemeProvider'
import { LandingPage } from '@/pages/LandingPage'

export default function App() {
  return (
    <ThemeProvider>
      <LandingPage />
    </ThemeProvider>
  )
}
